<template>
  <VContainer
    class="pt-10"
    fluid
  >
    <SContactUs @setGlobalLoading="setGlobalLoading" />
  </VContainer>
</template>

<script lang="ts">
export default {
  name: 'ContactUsPage',
};
</script>

<script setup lang="ts">
import { SContactUs } from '@slg/web-customer-shared';
import { useStore } from '@/composables';

const store = useStore();

function setGlobalLoading(loadingState: boolean) {
  store.commit('common/setGlobalLoading', loadingState);
}
</script>

<style scoped>

</style>
